<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import { useBreakpoints } from '@vueuse/core'

const breakpoints: any = useBreakpoints({ useMobileFilterSidebar: 1100 })

const useMobileFilterSidebar = breakpoints.smallerOrEqual('useMobileFilterSidebar')

const FilterMobile = defineAsyncComponent(() => import('./SearchListSidebarViewMobile.vue'))
const FilterDesktop = defineAsyncComponent(() => import('./SearchListSidebarViewDesktop.vue'))
</script>

<template>
  <filter-mobile v-if="useMobileFilterSidebar" />
  <filter-desktop v-else />
</template>
